import React, { useEffect } from 'react';
import './Home.css';
import Navbar from '../H&F/Navbar';
import Footer from '../H&F/Footer';
import TVAMAN1 from '../images/TVMAN1.webp';
import Discliamber from './Discliamer'

import TVMAN1 from '../images/TVMAN1.webp';
import TVMAN2 from '../images/TVMAN2.webp';
import TVMAN3 from '../images/TVMAN3.webp';
import TVMAN4 from '../images/TVMAN4.webp';
import TVMAN5 from '../images/TVMAN5.webp';
import TVMAN6 from '../images/TVMAN6.webp';

export default function TVSERVICE() {


   useEffect(() => {
      window.scrollTo(0, 0); // Scroll to the top of the page
    }, []);

  
const handleSubmit = async (e) => {
  e.preventDefault();
  const form = e.target;

  const formData = {
    name: form.name.value,
    phone: form.phone.value,
    location: form.location.value,
    issue: `  ${form.issue.value}
    
    - this calls coming from madurai 2.0 Nagaraj Account (HomeApplianceServiceMadurai.in)
    `, 
    toMail: "expresshelplinecare@gmail.com",
  };

  const spinner = document.getElementById("spinnerOverlay");
  if (spinner) spinner.style.display = "flex";

  try {
    const res = await fetch(
      "https://form.e2ecrm.in/api/sendmail",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      }
    );

    if (!res.ok) {
      throw new Error(`Server responded with ${res.status}`);
    }

    let data;
    try {
      data = await res.json();
    } catch {
      throw new Error("Invalid JSON response from server");
    }

    alert(data.message || "Complaint submitted successfully!");
    form.reset();
  } catch (err) {
    console.error("Form submit error:", err);
    alert(`Error sending complaint: ${err.message}`);
  } finally {
    if (spinner) spinner.style.display = "none";
  }
};
 

  
  return (
    <>
         <div><Navbar /></div>
   
        
           <section id="hero" style={{ backgroundImage: `url(${TVAMAN1})`}}>
             <div className="hero-content">
              <h1>Trusted TV Repair Professionals</h1>
<p>Professional technicians for all types of TV repairs. Fast service, affordable pricing, and guaranteed results every time.</p>
 <a href="tel:+918610867933" className="hero-btn">+91 86108 67933</a>
             </div>
             
      {/* Right Form */}
      <div className="form-container">
        <form id="bookingForm" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Enter your full name"
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder="Enter your mobile number"
            required
          />
          <input
            type="text"
            name="location"
            placeholder="Enter your complete address"
            required
          />
          <textarea
            name="issue"
            placeholder="Describe your appliance problem"
            required
          ></textarea>
             <p
  style={{
    marginTop: "12px",
    fontSize: "14px",
    color: "#ffffff",
    fontWeight: "700",
    textAlign: "center",
  }}
>
  Your information is kept secure and used only for your service request.
</p>
          <button type="submit">Book Complaint</button>
        </form>
      </div>
     

    {/* Dot Loading */}
    <div id="spinnerOverlay" className="spinner-overlay">
      <div className="dot-loader">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p className="loading-text">Booking your complaint</p>
    </div>
 
           </section>
   
   
   
{/*    
           <section class="contact-icons">
     <div class="contact-item phone">
       <a href="tel:+918610867933" class="icon-link">
         <span class="icon phone-icon"></span>
         <h5>Call Now</h5>
       </a>
     </div>
     <div class="contact-item whatsapp">
       <a href="https://wa.me/8610867933" class="icon-link">
         <span class="icon whatsapp-icon fab fa-whatsapp"></span>
         <h5>WhatsApp Now</h5> 
       </a>
     </div>
     <div class="contact-item mail">
       <a href="#" class="icon-link">
         <span class="icon mail-icon"></span>
         <h5>Email Now</h5>
       </a>
     </div>
   </section> */}
   
   
   
   
   
   
   
   
   
   
   
           {/* <section id="about">
     <div class="container">
       <div class="row">
         <div class="col-lg-12 col-md-12 col-sm-12 col-12">
           <h2>About Us</h2>
           <p class="about-description">
             We are a trusted home appliance service company with over 6 years of experience providing exceptional service and 100% customer satisfaction. Our experts are skilled in servicing a wide range of home appliances, ensuring that your household operates smoothly.
           </p>
   
           <div class="services">
             <div class="service-item">
               <img src={WASHIGIMAGE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
               <h3 class="service-title">Washing Machine Service</h3>
             </div>
             <div class="service-item">
             <img src={ACSERVICE1} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
               <h3 class="service-title" id="UPDOWN">AC Service</h3>
             </div>
             <div class="service-item">
             <img src={FRIDGESERVICE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
               <h3 class="service-title" id="UPDOWN">TV Service</h3>
             </div>
             <div class="service-item">
             <img src={MICROSERVICE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
               <h3 class="service-title">Microwave Oven Service</h3>
             </div>
             <div class="service-item">
             <img src={TVSERVICE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
               <h3 class="service-title">Fridge Service</h3>
             </div>
             <div class="service-item">
             <img src={WATERHEATERSERVICE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
               <h3 class="service-title">Water Heater Service</h3>
             </div>
             <div class="service-item">
             <img src={WATERPURIFIERSERVICE} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
               <h3 class="service-title">Water Purifier Service</h3>
             </div>
           </div>
   
           <p class="about-footer">
             With over 6+ years of experience and a 100% customer satisfaction guarantee, we ensure your appliances are in good hands.
           </p>
         </div>
       </div>
     </div>
   </section>
   
    */}
   
   
   
   
   
   
   
   <section id="how-we-work">
     <h2>How We Work</h2>
     <div class="work-cards">
       <div class="work-card">
         <i class="fas fa-bullhorn"></i>
         <h3>Promotion</h3>
         <p>We promote our website using Google Ads to get daily regular customers.</p>
       </div>
       <div class="work-card">
         <i class="fas fa-phone-alt"></i>
         <h3>Contact Us</h3>
         <p>Customers can reach us directly via the phone call option available on our website.</p>
       </div>
       <div class="work-card">
         <i class="fas fa-clipboard-list"></i>
         <h3>Complaint Registration</h3>
         <p>Our customer team registers the issue and forwards it to our technician.</p>
       </div>
       <div class="work-card">
         <i class="fas fa-calendar-check"></i>
         <h3>Technician Visit</h3>
         <p>Our technician gets an appointment and visits the customer's place to resolve the issue within 3-4 hours.</p>
       </div>
       <div class="work-card">
         <i class="fas fa-money-check-alt"></i>
         <h3>Service Charge</h3>
         <p>The basic service charge is ₹300 across Tamil Nadu. Spare parts charges are separate.</p>
       </div>
     </div>
   </section>
   
   
   <section id="gallery">
     <h2>Our Gallery</h2>
     <div class="gallery-grid">
       <div class="gallery-item large-item">
         <img src={TVMAN1} alt="Image 1"/>
       </div>
       <div class="gallery-item medium-item" >
         <img src={TVMAN2} alt="Image 2"/>
       </div>
       <div class="gallery-item medium-item" >
         <img src={TVMAN3} alt="Image 3"/>
       </div>
       <div class="gallery-item large-item">
         <img src={TVMAN4} alt="Image 4"/>
       </div>
       <div class="gallery-item medium-item" >
         <img src={TVMAN5} alt="Image 5"/>
       </div>
       <div class="gallery-item medium-item" >
         <img src={TVMAN6} alt="Image 6"/>
       </div>
     
     </div>
   </section>
   
   
   <section id="tech-special">
     <h2>Our Key Benefits</h2>
     <div class="benefit-cards">
       <div class="benefit-card">
         <i class="fas fa-cogs"></i>
         <h3>Tech Specialist</h3>
         <p>Our team consists of highly skilled technicians who specialize in all home appliance repairs.</p>
       </div>
       <div class="benefit-card">
         <i class="fas fa-wrench"></i>
         <h3>Quick Fixer</h3>
         <p>We diagnose and fix issues quickly, minimizing any inconvenience to our customers.</p>
       </div>
       <div class="benefit-card">
         <i class="fas fa-truck-fast"></i>
         <h3>Fast Delivery</h3>
         <p>We offer quick response times and arrive promptly at your location to deliver our services.</p>
       </div>
       <div class="benefit-card">
         <i class="fas fa-users"></i>
         <h3>Customer Friendly</h3>
         <p>Our customer support team is available to assist you every step of the way with a friendly approach.</p>
       </div>
       <div class="benefit-card">
         <i class="fas fa-check-circle"></i>
         <h3>High Quality Work</h3>
         <p>We ensure that every service we offer meets the highest quality standards and customer satisfaction.</p>
       </div>
     </div>
   </section>
   
   
   
   
   
   
   
   
   
   
   <section id="our-services">
     <h2>Our Services</h2>
     <div class="container">
      
      
       <div class="row service-item-washing-machine">
         <div class="col-md-6">
           <img src={TVMAN1} alt="Washing Machine Service" title="Washing Machine Service" class="img-fluid" />
         </div>
         <div class="col-md-6">
           <h3 id="service-heading-washing-machine">Tv Installation Service</h3>
           <p id="service-description-washing-machine">Choose our TV installation service for a seamless and professional setup, ensuring perfect alignment, secure mounting, and optimal viewing experience.</p>
         </div>
       </div>
   
     
       <div class="row service-item-ac-service">
         <div class="col-md-6">
           <img src={TVMAN2} alt="AC Service" title="AC Service" class="img-fluid" />
         </div>
         <div class="col-md-6">
           <h3 id="service-heading-ac-service">Tv Cleaning</h3>
           <p id="service-description-ac-service">Our TV cleaning service ensures your television stays dust-free and operates efficiently, enhancing picture quality and extending its lifespan.</p>
         </div>
       </div>
   
    
       <div class="row service-item-fridge-service">
         <div class="col-md-6">
           <img src={TVMAN3} alt="Fridge Service" title="Fridge Service" class="img-fluid" />
         </div>
         <div class="col-md-6">
           <h3 id="service-heading-fridge-service">Display Service </h3>
           <p id="service-description-fridge-service">We offer comprehensive TV display repair services that restore your television's picture quality and ensure a seamless viewing experience.</p>
         </div>
       </div>
   
      
       <div class="row service-item-tv-service">
         <div class="col-md-6">
           <img src={TVMAN4} alt="TV Service" title="TV Service" class="img-fluid" />
         </div>
         <div class="col-md-6">
           <h3 id="service-heading-tv-service">TV Service</h3>
           <p id="service-description-tv-service">Our TV service ensures your television works perfectly, with expert repair solutions for all brands and models.</p>
         </div>
       </div>
   
       
       <div class="row service-item-microwave-oven-service">
         <div class="col-md-6">
           <img src={TVMAN5} alt="Microwave Oven Service" title="Microwave Oven Service" class="img-fluid" />
         </div>
         <div class="col-md-6">
           <h3 id="service-heading-microwave-oven-service">Display Changing</h3>
           <p id="service-description-microwave-oven-service">Get reliable display changing services that ensure vibrant picture quality and restore your TV's visual performance. We handle all types of display issues with precision.</p>
         </div>
       </div>
   
       
       <div class="row service-item-water-heater-service">
         <div class="col-md-6">
           <img src={TVMAN6} alt="Water Heater Service" title="Water Heater Service" class="img-fluid" />
         </div>
         <div class="col-md-6">
           <h3 id="service-heading-water-heater-service">Tv Speaker Service</h3>
           <p id="service-description-water-heater-service">Ensure clear and powerful sound with our expert TV speaker service, designed to repair and maintain your TV's audio performance effectively.</p>
         </div>
       </div>
   
      
       
     </div>
   </section>
   
   <section id="working-hours">
     <h2>Our Working Hours</h2>
     <div class="container">
       <div class="row">
         <div class="col-md-12">
           <div class="working-day">
           <p id="sunday" className="day">Sunday: <span className="status" style={{ color: 'red' }}>Closed</span></p>
   
   
   
           </div>
           <div class="working-day">
             <p id="monday" class="day">Monday: <span class="status">9 AM - 9 PM</span></p>
           </div>
           <div class="working-day">
             <p id="tuesday" class="day">Tuesday: <span class="status">9 AM - 9 PM</span></p>
           </div>
           <div class="working-day">
             <p id="wednesday" class="day">Wednesday: <span class="status">9 AM - 9 PM</span></p>
           </div>
           <div class="working-day">
             <p id="thursday" class="day">Thursday: <span class="status">9 AM - 9 PM</span></p>
           </div>
           <div class="working-day">
             <p id="friday" class="day">Friday: <span class="status">9 AM - 9 PM</span></p>
           </div>
           <div class="working-day">
             <p id="saturday" class="day">Saturday: <span class="status">9 AM - 9 PM</span></p>
           </div>
         </div>
       </div>
     </div>
   </section>
   
   
   
   
   
   
   
   
   <section id="faq-section">
     <h2>Frequently Asked Questions (FAQ)</h2>
   
     <table class="table table-striped">
     <thead>
  <tr>
    <th>Service</th>
    <th>Question</th>
    <th>Answer</th>
  </tr>
</thead>
<tbody>
  <tr>
    <td>TV Service</td>
    <td>How often should I service my TV?</td>
    <td>It is recommended to service your TV at least once a year to maintain optimal performance and prevent unexpected issues.</td>
  </tr>
  <tr>
    <td>TV Service</td>
    <td>How do I know when my TV needs servicing?</td>
    <td>If your TV screen is flickering, has no picture, or the sound is distorted, it is time for a service.</td>
  </tr>
  <tr>
    <td>TV Service</td>
    <td>What are the signs that my TV needs repair?</td>
    <td>Common signs include the TV not turning on, the picture freezing, or experiencing audio problems.</td>
  </tr>
  <tr>
    <td>TV Display Service</td>
    <td>Why is my TV screen flickering or losing picture?</td>
    <td>Flickering or loss of picture can be due to a malfunctioning display, loose connections, or an issue with the power supply.</td>
  </tr>
  <tr>
    <td>TV Speaker Service</td>
    <td>What should I do if my TV has no sound?</td>
    <td>If your TV has no sound, the issue could be with the internal speakers or the audio settings. We recommend getting it checked by a professional.</td>
  </tr>
  <tr>
    <td>TV Service</td>
    <td>How can I tell if my TV needs servicing?</td>
    <td>If you're experiencing poor picture quality, distorted sound, or the TV is unresponsive, it's time to get your TV serviced.</td>
  </tr>
  <tr>
    <td>TV Service</td>
    <td>When should I replace the TV remote?</td>
    <td>If the TV remote is unresponsive, even after replacing the batteries, it may need to be repaired or replaced.</td>
  </tr>
</tbody>

     </table>
   </section>
   
   
   <div><Discliamber/></div>
   
   
   
         <div><Footer /></div>
       </>
  )
}
